export default {
  region: 'us-east-1',
  cognitoUserPoolId: 'us-east-1_2fYoaKdn9',
  cognitoUserPoolWebClientId: '6hn5iaun3uud411d132qg37nhl',
  cognitoIdentityPoolId: 'us-east-1:e1d24a12-6e78-401f-bd0c-2f851e96cb21',
  cognitoDomain: 'pv-mme-dynamic-ads-itl.auth.us-east-1.amazoncognito.com',
  redirectSignIn: 'https://itl.dynamic-ads.video.amazon.dev/auth-callback',
  redirectSignOut: 'https://itl.dynamic-ads.video.amazon.dev/',
  apiServerBaseUrl: 'https://api.itl.dynamic-ads.video.amazon.dev',
  stage: 'itl',
  benderApiServerBaseUrl: 'https://api.beta.bender.dynamic-ads.video.amazon.dev',
  fryApiServerBaseUrl: 'https://api.itl.fry.dynamic-ads.video.amazon.dev',
  loggerBaseUrl: 'https://logger.itl.dynamic-ads.video.amazon.dev/{proxy+}',
  monitoringBaseUrl: 'https://monitoring.itl.dynamic-ads.video.amazon.dev/{proxy+}',
  featureFlags: 'enableReportingDashboard,enableBlocklist,enableAbTesting,enableSpotlightLal,enablePublisherConfigs,enablePublisherConfigCampaignForm',
  spotlightApiGatewayBaseUrl: 'https://beta.spotlight.video.amazon.dev',
  productsBucketName: '',
  mediaBucketName: 'leela-media-978184426417-us-east-1-itl',
  agentCoreWsUrl: 'wss://bedrock-agentcore.us-east-1.amazonaws.com/runtimes/arn:aws:bedrock-agentcore:us-east-1:978184426417:runtime/leela_agent_orchestrator_itl-vnwUxGG1fw/ws',
};
